import { defineComponent as _defineComponent } from 'vue'
import {computed, onMounted, ref} from "vue";
import {useUserStore} from "@/store/user.store";
import {LoginTypeEnum, useUserServiceStore} from "@/store/userService.store";
import {useRouter} from "vue-router";
import {useI18n} from "vue-i18n";
import ProvideAddresInfoModal from "@/components/buyTokens/modals/ProvideAddresInfoModal.vue";
import {AddressType} from "@/components/buyTokens/modals/AddressType";
import {useToast} from "vue-toastification";
import {useContextStore} from "@/store/context.store";
import TooltipComponent from "@/components/TooltipComponent.vue";
import Button from "primevue/button";
import LoginPopUp from "@/components/layout/loginPopup/LoginPopUp.vue";
import {addDotsInsideTooLongString} from "@/utils/string-formatter";
import IconComponent from "@/components/features/IconComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountInfo',
  props: {
    accordion: { type: Boolean, required: true }
  },
  emits: ['openModal', 'openApproval'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();


const emit = __emit;

const props = __props;

const toast = useToast();
const loginPopupStatus = ref(false);
const isLoggedIn = computed(() =>{
  return useUserStore().isLoggedIn;
});

const isLogedInInService = computed(() => {
  return useUserServiceStore().isLoggedIn;
});

const isTermsAccepted = computed(() =>{
  return useUserServiceStore().isTermsAccepted;
});

const usersWallet = computed(() => {
  return useUserStore().getAccount.address;
});

const router = useRouter();
const showClosedTab = ref(true);

onMounted(() => {
  if(!props.accordion){
    open.value = true;
    showClosedTab.value = false;
  }
});

const showAddressInfoModal = ref(false);
const showAddressInfoModalAddressType = ref(AddressType.KEPLR);
const connectMetamask = () => {
  useUserStore().connectMetamask();
};
function provideClaimerAddress(){
  if(!isLoggedIn.value && claimAddress.value == undefined) {
    loginPopupStatus.value = true;
  } else {
    onShowInfoModal(AddressType.KEPLR);
  }
}

const onShowInfoModal = (addressType: AddressType) => {
  showAddressInfoModalAddressType.value = addressType;
  showAddressInfoModal.value = true;
};

function closeProvideAddressModalClose(){
  showAddressInfoModal.value = false;
}
function provideSourceAddress(){
  if(useUserStore().metamaskConnectionInfo.address == '') {
    useUserStore().connectMetamask(() => {
      onShowInfoModal(AddressType.METAMASK);
    });
  } else {
    onShowInfoModal(AddressType.METAMASK);
  }
}




const c4eAddress = computed(() => {
  return useUserStore().getAccount.address;
});

function addressConfirmed(){
  showAddressInfoModal.value = false;
  if(showAddressInfoModalAddressType.value == AddressType.KEPLR) {
    if (usersWallet.value) {
      useUserServiceStore().initEmailKeplrPairing(c4eAddress.value, onSuccessConnect, onFail);
    } else {
      toast.error('You have to be logged in with Email');
    }
  }
  if(showAddressInfoModalAddressType.value == AddressType.METAMASK) {
    console.log('Connect metamask account');

    useUserServiceStore().initEmailMetamaskPairing(useUserStore().metamaskConnectionInfo.address, onSuccessConnect, onFail);
  }
}
const onSuccessConnect = () => {
  useContextStore().addressType = showAddressInfoModalAddressType.value;
  router.push({name: 'provideVerificationCode'});
};

function onFail(){
//
}

const open = ref(false);

const address = computed(() =>{
  return useUserStore().getAccount.address;
});

const sourceAddress = computed(() =>{
  return useUserServiceStore().ethereumAddress;
});

const claimAddress = computed(() =>{
  return useUserServiceStore().claimAddress;
});
const onKycStart = () => {
  useUserServiceStore().initKycSession(true).then(() => {
    router.push({name: 'kyc'});
  });

};
const i18n = useI18n();
const getLoginType = () => {
  const loginType = useUserServiceStore().getLoginType;
  if(loginType == LoginTypeEnum.EMAIL) {
    return i18n.t('ENUMS.LOGIN_TYPE.EMAIL');
  } else if(loginType == LoginTypeEnum.KEPLR) {
    return i18n.t('ENUMS.LOGIN_TYPE.KEPLR');
  } else if(loginType == LoginTypeEnum.METAMASK) {
    return i18n.t('ENUMS.LOGIN_TYPE.METAMASK');
  }
  return i18n.t('ENUMS.LOGIN_TYPE.NONE');
};

function onCopy(txt: string){
  navigator.clipboard.writeText(txt);
}

const __returned__ = { emit, props, toast, loginPopupStatus, isLoggedIn, isLogedInInService, isTermsAccepted, usersWallet, router, showClosedTab, showAddressInfoModal, showAddressInfoModalAddressType, connectMetamask, provideClaimerAddress, onShowInfoModal, closeProvideAddressModalClose, provideSourceAddress, c4eAddress, addressConfirmed, onSuccessConnect, onFail, open, address, sourceAddress, claimAddress, onKycStart, i18n, getLoginType, onCopy, get useUserStore() { return useUserStore }, get useUserServiceStore() { return useUserServiceStore }, ProvideAddresInfoModal, get AddressType() { return AddressType }, TooltipComponent, get Button() { return Button }, LoginPopUp, get addDotsInsideTooLongString() { return addDotsInsideTooLongString }, IconComponent }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})